<template>
  <PageContainer title="Auditoria de aulas">
    <div slot="header">
      <LoadingSpinner v-if="loadingDownload" :size="40" />

      <Button v-else @handle:click="download" text="Gerar relatório" color="primary" :disabled="loadingDownload">
        <TrayArrowDown :size="18" />
      </Button>
    </div>

    <div class="d-flex justify-content-center" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box space="medium" v-else class="page-content">
      <form class="aulas-form" @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Auto escola" placeholder="Selecione"
              :modelValue="schema" @update:modelValue="$event => (schema = $event)" :disabled="loading" />

            <Period legend="Data" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (initialDate = $event)"
              @update:secondModelValue="$event => (finalDate = $event)" :disabled="loading" />

            <Select class="input-full" :options="classTypes" legend="Tipo de aula" placeholder="Selecione"
              :modelValue="classType" @update:modelValue="$event => (classType = $event)" :disabled="loading" />
          </div>

          <div class="inputs-row">
            <Select class="input-full" :filtered="true" :options="alunos" legend="Aluno"
              placeholder="Digite o nome do aluno" :modelValue="aluno" @update:modelValue="$event => (aluno = $event)"
              :disabled="loadingAluno || loading || !schema" />

            <Select class="input-full" :options="instrutores" legend="Instrutor(a)" placeholder="Selecione um instrutor"
              :modelValue="instrutor" @update:modelValue="$event => (instrutor = $event)"
              :disabled="loadingInstrutor || loading || !schema" />

            <Select v-if="classType === 'pratica'" class="input-full" :options="categoriaOptions" legend="Categoria"
              placeholder="Selecione" :modelValue="categoria" @update:modelValue="$event => (categoria = $event)"
              :disabled="loading" />
          </div>

          <div class="buttons">
            <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
              :disabled="loading">
              <CloseCircleOutline :size="18" />
            </Button>

            <Button type="submit" text="Consultar" color="primary" :disabled="loading">
              <Magnify :size="18" />
            </Button>
          </div>
        </div>
      </form>

      <div class="d-flex justify-content-center" v-if="loading">
        <LoadingSpinner />
      </div>

      <div class="table-container" v-else-if="!loading && (teoricas.length > 0 || praticas.length > 0)">
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchAulas" />

        <Table v-if="classType === 'teorica'" :headers="['Instrutor', 'Matéria', 'Inicio', 'Fim']">
          <tr v-for="aula in teoricas" :key="aula.id_aulas_teoricas">
            <td>{{ aula.instrutor }}</td>
            <td>{{ aula.materia }}</td>
            <td>{{ utils.formatDate(aula.inicio) }}</td>
            <td>{{ utils.formatDate(aula.fim) }}</td>
            <!-- <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="openModalTeorica(aula.id_turma_teorica, aula.virtual, aula.id_aluno)"
                    color="primary" title="Fotos" :disabled="loadingActions">
                    <ImageMultiple :size="19" />
                  </IconButton>
                </div>
              </div>
            </td> -->
          </tr>
        </Table>

        <Table v-if="classType === 'pratica'" :headers="['Auto escola', 'Instrutor', 'Veículo', 'Aluno', 'Data']">
          <tr v-for="aula in praticas" :key="aula.id_aulas_praticas">
            <td>{{schemaOptions.find(opt => opt.value === schema).text}}</td>
            <td>{{ aula.nomeInstrutor }}</td>
            <td>{{ aula.numeroPlaca }}</td>
            <td>{{ aula.nomeAluno }}</td>
            <td>{{ utils.formatDate(aula.data_aula) }}</td>
            <!-- <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="openModalTeorica(aula.id_turma_teorica, aula.virtual, aula.id_aluno)"
                    color="primary" title="Fotos" :disabled="loadingActions">
                    <ImageMultiple :size="19" />
                  </IconButton>
                </div>
              </div>
            </td> -->
          </tr>
        </Table>
      </div>
    </Box>

    <Modal ref="presenca" title="Presença do aluno(a)">
      <div class="presencas-container">
        <table class="presencas-table">
          <thead>
            <tr class="presencas-table-header">
              <th>Útlimas Fotos</th>
              <th>Tipo</th>
              <th>Horário</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(presenca, index) in modalPresencas" :key="index" class="presencas-table-content">
              <td>
                <img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
              </td>
              <td v-show="presenca.tipo == 0">Entrada</td>
              <td v-show="presenca.tipo == 1" class="red">Saída</td>
              <td v-show="presenca.tipo == 2">Intervalo</td>
              <td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
              <td>{{ utils.formatDate(presenca.created_at) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="presencas-photos-container">
          <h3>Fotos aulas teóricas</h3>

          <div class="photos">
            <span v-if="!modalFotos.length">Sem fotos teóricas</span>
            <img v-for="(foto, index) in modalFotos" :key="index" :src="'data:image/jpg;base64, ' + foto.foto"
              alt="Fotos teóricas">
          </div>
        </div>
      </div>
    </Modal>
  </PageContainer>
</template>

<script>
import utils from '../../services/utils'
import _export from '../../services/export'
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Period from 'core/Period'
import Input from 'core/Input'
import Button from 'core/Button'
import Paginate from 'core/Paginate'
import Table from 'core/Table'
import IconButton from 'core/IconButton'
import Modal from 'core/Modal'
import Magnify from 'icons/Magnify'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import ImageMultiple from 'icons/ImageMultiple'
import TrayArrowDown from 'icons/TrayArrowDown'

export default {
  name: "AuditoriaAulas",
  components: {
    PageContainer,
    Box,
    LoadingSpinner,
    Select,
    Period,
    Input,
    Button,
    Paginate,
    Table,
    IconButton,
    Modal,

    Magnify,
    CloseCircleOutline,
    ImageMultiple,
    TrayArrowDown,
  },
  data() {
    return {
      utils: utils,
      schema: null,
      initialDate: '',
      finalDate: '',
      classType: null,
      aluno: null,
      instrutor: null,
      categoria: null,
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 1,
      },
      schemaOptions: [],
      classTypes: [
        { text: 'Teórica', value: 'teorica' },
        { text: 'Prática', value: 'pratica' },
      ],
      alunos: [],
      instrutores: [],
      categoriaOptions: [
        { text: 'A', value: 'A' },
        { text: 'B', value: 'B' },
        { text: 'C', value: 'C' },
        { text: 'D', value: 'D' },
        { text: 'E', value: 'E' },
      ],
      teoricas: [],
      praticas: [],
      modalFotos: [],
      modalPresencas: [],
      loaded: false,
      loading: false,
      loadingAluno: false,
      loadingInstrutor: false,
      loadingActions: false,
      loadingDownload: false,
    }
  },
  async mounted() {
    await this.fetchCfcs()


    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then(res => {
          this.schemaOptions = res.body.dados.map(cfc => ({
            value: cfc.tenant_schema,
            text: cfc.nome_fantasia,
          }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async loadAlunos(schema) {
      this.loadingAluno = true

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/select/${schema}`)
        .then(response => {
          this.alunos = response.body.dados
        })
        .catch(err => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingAluno = false
        })
    },
    async fetchInstrutores(schema) {
      this.loadingInstrutor = true

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/instrutor/fetch${schema ? `?schema=${schema}` : ''}`)
        .then(res => {
          this.instrutores = res.body.dados.map(instrutor => ({ value: instrutor.id_instrutor, text: instrutor.nome }))
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar instrutores.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingInstrutor = false
        })
    },
    validate() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma auto escola.', {
          position: 'top-right',
        })
        return false
      }

      if (!this.initialDate || !this.finalDate) {
        this.$toasted.show('Preencha as datas!', {
          position: 'top-right',
        })
        return false
      }

      if (this.initialDate > this.finalDate) {
        this.$toasted.show('A data inicial deve ser anterior à data final!', {
          position: 'top-right',
        })
        return false
      }

      if (!this.classType) {
        this.$toasted.show('Selecione um tipo de aula.', {
          position: 'top-right',
        })
        return false
      }

      if (!this.aluno) {
        this.$toasted.show('Selecione um aluno.', {
          position: 'top-right',
        })
        return false
      }

      if (!this.instrutor) {
        this.$toasted.show('Preencha o instrutor.', {
          position: 'top-right',
        })
        return false
      }

      if (this.classType === 'pratica' && !this.categoria) {
        this.$toasted.show('Selecione uma categoria.', {
          position: 'top-right',
        })
        return false
      }

      return true
    },
    async fetchAulas(page = 1) {
      this.loading = true

      const params = {
        page,
        schema: this.schema,
        initialDate: this.initialDate,
        finalDate: this.finalDate,
        aluno: this.aluno,
        instrutor: this.instrutor,
      }

      if (this.categoria) {
        params.categoria = this.categoria
      }

      if (this.classType === 'teorica') {
        await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/auditoria/aulas/teoricas`, { params })
          .then(res => {
            const dados = res.body.dados

            if (dados.data.length === 0) {
              this.$toasted.show('Nenhuma aula encontrada.', {
                position: 'top-right',
              })
              return
            }

            this.teoricas = dados.data

            this.paginationData = {
              currentPage: dados.current_page,
              lastPage: dados.last_page,
              total: dados.total,
            }
          })
          .catch(err => {
            this.$toasted.show('Erro!' + err.body.mensagem, {
              position: 'top-right',
            })
          })
      } else if (this.classType === 'pratica') {
        await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/auditoria/aulas/praticas`, { params })
          .then(res => {
            const dados = res.body.dados

            this.praticas = dados.data

            this.paginationData = {
              currentPage: dados.current_page,
              lastPage: dados.last_page,
              total: dados.total,
            }
          })
          .catch(err => {
            this.$toasted.show('Erro!' + err.body.mensagem, {
              position: 'top-right',
            })
          })
      }

      this.loading = false
    },
    async handleSubmit() {
      if (this.validate()) {
        await this.fetchAulas()
      }
    },
    clearInputs() {
      this.schema = null
      this.initialDate = ''
      this.finalDate = ''
      this.classType = null
      this.aluno = null
      this.instrutor = ''
      this.categoria = null
    },
    async openModalTeorica(id, virtual, idAluno) {
      const params = {
        schema: this.schema,
        aluno: idAluno,
        turma: id,
        virtual,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/auditoria/fotos/teoricas`, { params })
        .then((res) => {
          this.modalFotos = res.body.dados.fotos_teoricas
          this.modalPresencas = res.body.dados.presencas

          this.$refs.presenca.open()
        })
    },
    async download() {
      if (this.validate()) {
        this.loadingDownload = true

        const params = {
          type: this.classType,
          schema: this.schema,
          initialDate: this.initialDate,
          finalDate: this.finalDate,
          aluno: this.aluno,
          instrutor: this.instrutor,
        }

        if (this.categoria) {
          params.categoria = this.categoria
        }

        this.$toasted.show('Baixando Relatório...', {
          position: 'top-right',
        })

        await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/auditoria/relatorio`, { params })
          .then(res => {
            _export.downloadPDF(res.body.dados.relatorio, 'relatorio-auditoria-aulas')
            _export.downloadZIP(res.body.dados.fotos, 'relatorio-auditoria-aulas-fotos')
          })
          .catch(err => {
            this.$toasted.show('Erro!' + err.body.mensagem, {
              position: 'top-right',
            })
          })
          .finally(() => {
            this.loadingDownload = false
          })
      }
    }
  },
  watch: {
    async schema(newVal, oldVal) {
      if (newVal) {
        console.log(newVal)
        this.aluno = null
        this.instrutor = null

        await Promise.all([
          this.fetchInstrutores(newVal),
          this.loadAlunos(newVal),
        ])
      }
    },
    classType(newVal, oldVal) {
      if (newVal) {
        this.praticas = []
        this.teoricas = []
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .aulas-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }
  }
}

.presencas-container {
  width: 50vw;
  display: flex;
  flex-direction: column;
  gap: 2.0625rem;

  .presencas-table {
    tr {
      border: none;
    }

    .presencas-table-header {
      >th {
        padding: 0.5rem 0.5rem 2rem;
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;
      }
    }

    .presencas-table-content {
      >td {
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;

        &.red {
          color: #E91D23;
        }
      }

      img {
        width: 10.5rem;
        height: 10.5625rem;
        border-radius: 5.74px;
        border: 0.57px solid #A8A8A8;
        object-fit: contain;
      }
    }
  }

  .presencas-photos-container {
    display: flex;
    flex-direction: column;
    gap: 2.0625rem;

    h3 {
      margin: 0;
      display: flex;
      flex-direction: column;
      font-size: 1.5rem;
      font-weight: 700;
      text-align: left;
      color: #202224;
    }

    .photos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2.0625rem;

      >img {
        width: 5.375rem;
        height: 5.375rem;
        border-radius: 2.93px;
        border: 0.29px solid #A8A8A8;
      }
    }
  }
}
</style>